// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

:root {
  overflow-x: hidden;
  height: 100%;
}

* {
  font-family: "Roboto", sans-serif;
  font-weight: 200;
  box-sizing: border-box;
  outline: none;
}

*:focus {
  outline: none;
}

html,
body {
  margin: 0;
  padding: 0;
}

body {
  min-height: 100%;
  font-size: 1.3rem;
}
@media (max-width: 768px) {
  body {
    font-size: 1.2rem;
  }
}
@media (max-width: 576px) {
  body {
    font-size: 1.1rem;
  }
}

h1, h2, h3, h4, h5, h6 {
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

.container {
  width: 100%;
  max-width: 1200px;
  padding: 15px;
  box-sizing: border-box;
  margin: 0 auto;
}

hr.style-one {
  width: 90%;
  border: 0;
  height: 1px;
  background: #333;
  background-image: linear-gradient(to right, #ccc, #333, #ccc);
}

hr.style-two {
  width: 90%;
  border: 0;
  height: 1px;
  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));
}

hr.style-three {
  width: 90%;
  border: 0;
  border-bottom: 1px dashed #ccc;
  background: #999;
}

.error-color {
  color: #aa004f;
}

/**  **/
.profile-wrapper,
.shifts-dashboard,
.profile-components,
.profile-page-content--show-tab { /* Safari, Chrome and Opera > 12.1 */ /* Firefox < 16 */ /* Internet Explorer */ /* Opera < 12.1 */
  animation: fadein 1s;
  min-height: calc(100vh - 230px);
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/* Firefox < 16 */
/* Safari, Chrome and Opera > 12.1 */
/* Internet Explorer */
/* Opera < 12.1 */
.notification-dropdown-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: start;
  box-shadow: rgba(50, 50, 105, 0.15) 0 2px 5px 0, rgba(0, 0, 0, 0.05) 0 1px 1px 0;
  background-color: #ffffff;
}
.notification-dropdown-wrapper:after {
  content: " ";
  position: absolute;
  right: 30px;
  top: -15px;
  border-top: none;
  border-right: 15px solid transparent;
  border-left: 15px solid transparent;
  border-bottom: 15px solid white;
}
.notification-dropdown-wrapper {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  width: 200px;
}
.notification-dropdown-wrapper .notification-dropdown-info-title {
  border-bottom: 1px solid #bebebe;
  padding: 5px 0;
  font-size: 16px;
}
.notification-dropdown-wrapper .notification-dropdown-info {
  border-bottom: 1px solid #bebebe;
  padding: 5px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.notification-dropdown-wrapper .notification-dropdown-info:hover {
  background-color: #d6d6d6;
}
.notification-dropdown-wrapper .notification-dropdown-info .notification-dropdown-info-image img.profile-img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.notification-dropdown-wrapper .notification-dropdown-info .notification-dropdown-info-text {
  padding-left: 5px;
  text-decoration: none;
  color: #000000;
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/components/NotificationDropDown/styles.scss","webpack://./src/css/general.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;ACpBA;EACE,kBAAA;EACA,YAAA;ADuBF;;ACrBA;EFJE,iCAAA;EACA,gBEIqB;EACrB,sBAAA;EACA,aAAA;ADyBF;;ACvBA;EACE,aAAA;AD0BF;;ACxBA;;EAEE,SAAA;EACA,UAAA;AD2BF;;ACzBA;EACE,gBAAA;EACA,iBFTO;ACqCT;AC1BE;EAJF;IAKI,iBFbK;EC0CP;AACF;AC5BE;EAPF;IAQI,iBFjBK;ECgDP;AACF;;AC5BA;EF7BE,iCAAA;EACA,gBE6BqB;ADgCvB;;AC7BA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,cAAA;ADgCF;;AC7BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,6DAAA;ADgCF;;AC9BA;EACE,UAAA;EACA,SAAA;EACA,WAAA;EACA,oGAAA;ADiCF;;AC/BA;EACE,UAAA;EACA,SAAA;EACA,8BAAA;EACA,gBAAA;ADkCF;;AChCA;EACE,cC3DO;AF8FT;;AC9BA,OAAA;AACA;;;kCAIE,oCAAA,EACA,iBAAA,EACA,sBAAA,EACA,iBAAA;EACA,oBAAA;EACA,+BAAA;ADiCF;;AC9BA;EACE;IAAO,UAAA;EDkCP;ECjCA;IAAO,UAAA;EDoCP;AACF;AClCA,iBAAA;AAMA,oCAAA;AAMA,sBAAA;AAMA,iBAAA;ADrGA;EACE,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gFAAA;EACA,yBAAA;AA2JF;AAzJE;EACE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;EACA,oCAAA;EACA,mCAAA;EACA,+BAAA;AA2JJ;AA1KA;EDDE,iCAAA;EACA,gBCkBqB;EACrB,YAAA;AA4JF;AA3JE;EACE,gCAAA;EACA,cAAA;EACA,eAAA;AA6JJ;AA3JE;EACE,gCAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;AA6JJ;AA3JI;EACE,yBE/BG;AF4LT;AAzJM;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AA2JR;AAxJI;EACE,iBAAA;EACA,qBAAA;EACA,cAAA;AA0JN","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../css/breakpoints.scss\";\n@import \"../../css/colors.scss\";\n@import \"../../css/general.scss\";\n\n.notification-dropdown-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  box-shadow: rgba(50, 50, 105, 0.15) 0 2px 5px 0, rgba(0, 0, 0, 0.05) 0 1px 1px 0;\n  background-color: #ffffff;\n\n  &:after {\n    content: \" \";\n    position: absolute;\n    right: 30px;\n    top: -15px;\n    border-top: none;\n    border-right: 15px solid transparent;\n    border-left: 15px solid transparent;\n    border-bottom: 15px solid white;\n  }\n\n  @include font-roboto(100);\n  width: 200px;\n  .notification-dropdown-info-title {\n    border-bottom: 1px solid $color7;\n    padding: 5px 0;\n    font-size: 16px;\n  }\n  .notification-dropdown-info {\n    border-bottom: 1px solid $color7;\n    padding: 5px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n\n    &:hover {\n      background-color: $color8;\n    }\n\n    .notification-dropdown-info-image {\n      img.profile-img {\n        width: 20px;\n        height: 20px;\n        border-radius: 50%;\n      }\n    }\n    .notification-dropdown-info-text {\n      padding-left: 5px;\n      text-decoration: none;\n      color: #000000;\n      span {\n      }\n    }\n  }\n}\n","@import \"fonts\";\n@import \"breakpoints\";\n@import \"colors\";\n:root {\n  overflow-x: hidden;\n  height: 100%;\n}\n* {\n  @include font-roboto(200);\n  box-sizing: border-box;\n  outline: none;\n}\n*:focus {\n  outline: none;\n}\nhtml,\nbody {\n  margin: 0;\n  padding: 0;\n}\nbody {\n  min-height: 100%;\n  font-size: $font-lg;\n  \n  @media (max-width: $md){\n    font-size: $font-md;\n  }\n  @media(max-width:$sm){\n    font-size: $font-sm;\n  }\n}\n\nh1, h2, h3 ,h4, h5, h6 {\n  @include font-roboto(400);\n}\n\n.container {\n  width: 100%;\n  max-width: 1200px;\n  padding: 15px;\n  box-sizing: border-box;\n  margin: 0 auto;\n}\n\nhr.style-one {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background: #333;\n  background-image: linear-gradient(to right, #ccc, #333, #ccc);\n}\nhr.style-two {\n  width: 90%;\n  border: 0;\n  height: 1px;\n  background-image: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0));\n}\nhr.style-three {\n  width: 90%;\n  border: 0;\n  border-bottom: 1px dashed #ccc;\n  background: #999;\n}\n.error-color {\n  color: $color6;\n}\n\n\n\n/**  **/\n.profile-wrapper,\n.shifts-dashboard,\n.profile-components,\n.profile-page-content--show-tab {\n  -webkit-animation: fadein 1s; /* Safari, Chrome and Opera > 12.1 */\n  -moz-animation: fadein 1s; /* Firefox < 16 */\n  -ms-animation: fadein 1s; /* Internet Explorer */\n  -o-animation: fadein 1s; /* Opera < 12.1 */\n  animation: fadein 1s;\n  min-height: calc(100vh - 230px);\n}\n\n@keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Firefox < 16 */\n@-moz-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Safari, Chrome and Opera > 12.1 */\n@-webkit-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Internet Explorer */\n@-ms-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}\n\n/* Opera < 12.1 */\n@-o-keyframes fadein {\n  from { opacity: 0; }\n  to   { opacity: 1; }\n}","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
